export default __webpack_public_path__ + "static/media/RajaRajeswari.37d8fd97.png";